import React from 'react';
// import { Button } from '@roo/roo';
// import { getHost } from '../../utils';
// import { isInApp } from '../../utils/h5PC';
import { owlReportMetrics } from '@m2h/common/raptor';
// import buggerIcon from '../../assets/images/error.svg';
import './error.css';

const returnBack = () => {
  const locate = window.top ? window.top.location : window.location;
  owlReportMetrics({
    B_APP_ERROR_GOHOME_CLICK: 1,
  }, {
    ERROR_PAGE: `${locate.pathname}${locate.hash}`,
  });
  // TODO： 多端复用场景，严格区分app多个端
  locate.href = '/mpweb/home_page_main';
  // locate.href = `${getHost()}${isInApp() ? '/web/app/home' : '/'}`;
};
export default (
  <div className="errorMain">
    {/*<img src={buggerIcon} />*/}
    <span className="errorMainText">ERROR</span>
    {/*<Button onClick={() => returnBack()}>GO HOME</Button>*/}
  </div>
);
